import Header from './components/Header';
import Hero from './components/Hero';
import StoryOverview from './components/StoryOverview';
import Characters from './components/Characters';
import Analysis from './components/Analysis';
import EndingSection from './components/EndingSection';
import Ranking from './components/Ranking';
import Community from './components/Community';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer, { ScrollTop } from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <StoryOverview />
        <Characters />
        <Analysis />
        <EndingSection />
        <Ranking />
        <Community />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
}